import { defineComponent as _defineComponent } from 'vue'
import {
  HeadingDisplay,
  ContentDisplay,
  ButtonPrimary,
  ListDisplay,
  ConclusionStep
} from '@warrenbrasil/nebraska-web';
import { useRouter } from 'vue-router/composables';
import {
  trackCreatedSuccessClose,
  trackCreatedSuccessInvest
} from './track-events';


export default /*#__PURE__*/_defineComponent({
  __name: 'Created',
  setup(__props) {

const router = useRouter();

function handleNextClick() {
  trackCreatedSuccessInvest();
  router.push({
    name: 'wealthProductTransaction',
    params: { id: router.currentRoute.params.id }
  });
}

function handleCloseAction() {
  trackCreatedSuccessClose();
  router.push({ name: 'wealth' });
}

return { __sfc: true,router, handleNextClick, handleCloseAction, HeadingDisplay, ContentDisplay, ButtonPrimary, ListDisplay, ConclusionStep }
}

})